import { render, staticRenderFns } from "./AcquaintanceWithTheAccount.vue?vue&type=template&id=12b42034&"
import script from "./AcquaintanceWithTheAccount.vue?vue&type=script&lang=js&"
export * from "./AcquaintanceWithTheAccount.vue?vue&type=script&lang=js&"
import style0 from "./AcquaintanceWithTheAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports